import type { TypeFormFieldElement } from '../../../types/form';

import * as exSelectUtils from '../../select/utils';

// ----------------------------------------------------------------------------

function isFormFieldElement(element: Element): element is TypeFormFieldElement {
    return (
        element instanceof HTMLInputElement ||
        element instanceof HTMLSelectElement ||
        element instanceof HTMLTextAreaElement
    );
}

function stringifyFieldValue(value: unknown): string {
    if (value == null) {
        return '';
    }

    if (typeof value === 'string') {
        return value;
    }

    if (typeof value === 'number' || typeof value === 'boolean' || typeof value === 'bigint') {
        return `${value}`;
    }

    try {
        return JSON.stringify(value);
    } catch {
        return '';
    }
}

function normalizeSelectValue(value: unknown): string | string[] {
    if (Array.isArray(value)) {
        return value.map((item): any => stringifyFieldValue(item));
    }

    return stringifyFieldValue(value);
}

// ----------------------------------------------------------------------------

function fillForm(form: HTMLFormElement, data: Record<string, unknown>): void {
    const elements = Array.from(form.elements).filter(isFormFieldElement);

    for (const element of elements) {
        const name = element.name;

        //
        if (!name || !(name in data)) {
            continue;
        }

        //
        const value = data[name];

        //
        if (element instanceof HTMLInputElement) {
            //
            if (element.type === 'checkbox') {
                if (Array.isArray(value)) {
                    element.checked = value.includes(element.value);
                } else {
                    element.checked = Boolean(value);
                }
            }
            //
            else if (element.type === 'radio') {
                element.checked = element.value === stringifyFieldValue(value);
            }
            //
            else {
                element.value = stringifyFieldValue(value);
            }
        }
        //
        else if (element instanceof HTMLSelectElement) {
            exSelectUtils.setValue(element, normalizeSelectValue(value));
        }
        //
        else if (element instanceof HTMLTextAreaElement) {
            element.value = stringifyFieldValue(value);
        }
    }
}

// ----------------------------------------------------------------------------

export default fillForm;
